/**
 * Indicateurs d'une catégorie unique (`GET /v1/kpi/{categorie}`).
 *
 * Un GRV dont le compte de répartition ne tombe pas juste (`repartition`) affiche chaque part : c'est
 * le détail derrière une valeur agrégée, utile pour la catégorie maintenance (checklists à jour /
 * en retard / absentes, par exemple).
 */
import { useParams } from "react-router-dom";

import { Chargement, Erreur, ValeurOuRaison } from "../../shared/composants/Etats";
import { InfoBulle } from "../../shared/composants/InfoBulle";
import { useIndicateurs } from "./requetes";

const LIBELLE_CATEGORIE: Record<string, string> = {
  disponibilite: "Disponibilité",
  trackers: "Trackers",
  logistique: "Logistique",
  maintenance: "Maintenance",
  conformite: "Conformité",
  facturation: "Facturation",
  anomalies: "Anomalies",
};

export function EcranCategorieIndicateurs() {
  const { categorie = "" } = useParams<{ categorie: string }>();
  const requete = useIndicateurs(categorie);

  if (requete.isPending) return <Chargement libelle="Calcul des indicateurs…" />;
  if (requete.isError) {
    return <Erreur erreur={requete.error} reessayer={() => void requete.refetch()} />;
  }

  return (
    <section>
      <h1>{LIBELLE_CATEGORIE[categorie] ?? categorie}</h1>
      <div className="grille-indicateurs">
        {requete.data.data.map((indicateur) => (
          <article key={indicateur.code} className="carte-indicateur">
            <h3>
              {indicateur.libelle}
              <InfoBulle texte={indicateur.description} libelle={indicateur.libelle} />
            </h3>
            <ValeurOuRaison
              valeur={indicateur.valeur}
              unite={indicateur.unite}
              indisponibleCar={indicateur.indisponible_car}
            />
            {indicateur.repartition && (
              <ul className="repartition">
                {Object.entries(indicateur.repartition).map(([cle, valeur]) => (
                  <li key={cle}>
                    {cle} : {valeur}
                  </li>
                ))}
              </ul>
            )}
          </article>
        ))}
      </div>
    </section>
  );
}
